module.exports = __webpack_public_path__ + "static/media/details-27-image-2.ea0891dd.jpg";